import { A11yModule } from "@angular/cdk/a11y";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { RouterModule } from "@angular/router";

import { CallToActionComponent } from "@hermes/aphrodite/call-to-action";
import { DynamicBoxComponent } from "@hermes/aphrodite/dynamic-box";
import {
    ExpansionPanelComponent,
    ExpansionPanelPartDirective,
} from "@hermes/aphrodite/expansion-panel";
import { CheckboxComponent } from "@hermes/aphrodite/fields";
import { PriceSliderComponent } from "@hermes/aphrodite/price-slider";
import { RadioButtonComponent } from "@hermes/aphrodite/radio-button";
import { StickyWrapperComponent } from "@hermes/aphrodite/sticky-wrapper";
import { SvgRegistryService, svgCrossRounded } from "@hermes/aphrodite/svg";
import { SwitchButtonComponent } from "@hermes/aphrodite/switch-button";
import { GridFacade } from "@hermes/states/grid-filters-state";
import { TRAY_COMPONENT, TrayStateModule } from "@hermes/states/tray";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";

import { GridFilterColorAndSizeComponent } from "./components/grid-filter-color-and-size/grid-filter-color-and-size.component";
import { GridFilterListComponent } from "./components/grid-filter-list/grid-filter-list.component";
import { GridFiltersComponent } from "./components/grid-filters/grid-filters.component";
import { GridFilterIdSetterPipeModule } from "./pipes/grid-filter-id-setter/grid-filter-id-setter.pipe";
import { SwitchFilterCheckedPipe } from "./pipes/switch-filter-checked/switch-filter-checked.pipe";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TrayStateModule,
        A11yModule,
        CallToActionComponent,
        SwitchButtonComponent,
        ExpansionPanelComponent,
        ExpansionPanelPartDirective,
        CheckboxComponent,
        PriceSliderComponent,
        DynamicBoxComponent,
        RouterModule,
        SrOnlyNoSnippetDirective,
        GridFilterIdSetterPipeModule,
        StickyWrapperComponent,
        RadioButtonComponent,
    ],
    declarations: [
        GridFiltersComponent,
        GridFilterListComponent,
        GridFilterColorAndSizeComponent,
        SwitchFilterCheckedPipe,
    ],
    providers: [
        {
            provide: TRAY_COMPONENT,
            useValue: GridFiltersComponent,
        },
        GridFacade,
    ],
})
export class GridFiltersTrayModule {
    constructor(svgRegistryService: SvgRegistryService) {
        svgRegistryService.registerSvgs([svgCrossRounded]);
    }
}
